import { FileDownIcon, ListIcon, QrCodeIcon } from 'lucide-react'

const ProductExportMenuItems = [
  {
    label: 'export_as_excel',
    href: '/products/export/excel/create',
    icon: FileDownIcon
  },
  {
    label: 'excel_exports',
    href: '/products/export/excel',
    icon: ListIcon
  },
  {
    label: 'export_as_pdf',
    href: '/products/export/pdf/create',
    icon: FileDownIcon
  },
  {
    label: 'pdf_exports',
    href: '/products/export/pdf',
    icon: ListIcon
  },
  {
    label: 'export_as_qr',
    href: '/products/export/qr/create',
    icon: QrCodeIcon
  },
  {
    label: 'qr_exports',
    href: '/products/export/qr',
    icon: ListIcon
  }
]

export default ProductExportMenuItems
